import { useMemo } from 'react';
import Fuse from 'fuse.js';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';

type Props = {
  allOptions: TReactSelectOption[];
  selectedOptions: TReactSelectOption[];
  searchValue: string;
  filterSelected: boolean;
};

const useFilteredOptions = ({ allOptions, filterSelected, selectedOptions, searchValue }: Props) => {
  const searchableOptions = useMemo(() => {
    if (!filterSelected) return allOptions;
    const selectedValuesMap = new Map(selectedOptions.map((so) => [so.value, so]));
    return allOptions.filter((o) => !selectedValuesMap.has(o.value));
  }, [allOptions, filterSelected, selectedOptions]);

  const fuse = useMemo(() => {
    return new Fuse(searchableOptions, {
      keys: ['label'],
      isCaseSensitive: false,
      threshold: 0.3,
    });
  }, [searchableOptions]);

  const selectableOptions = useMemo(() => {
    if (!searchValue) return searchableOptions;

    return fuse.search(searchValue).map((o) => o.item);
  }, [fuse, searchValue, searchableOptions]);

  return useMemo(() => selectableOptions, [selectableOptions]);
};

export default useFilteredOptions;
